import { render, staticRenderFns } from "./Cirurgias.vue?vue&type=template&id=01441fc0&scoped=true"
import script from "./Cirurgias.vue?vue&type=script&lang=js"
export * from "./Cirurgias.vue?vue&type=script&lang=js"
import style0 from "@/assets/stylesheets/views/cirurgias/Cirurgias.scss?vue&type=style&index=0&id=01441fc0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01441fc0",
  null
  
)

export default component.exports